import { PickerInput } from '@epam/promo';
import { IEditable, useArrayDataSource } from '@epam/uui-core';
import { USER_ROLE, UserRole } from 'models/user.model';

export const UserRolePicker = ({
  value,
  onValueChange,
  isDisabled,
  isInvalid,
  validationMessage,
  validationProps,
}: IEditable<UserRole>) => {
  const roles = Object.keys(USER_ROLE)
    .filter((role) => role !== 'GUEST')
    .map((role) => ({
      id: role,
      value: USER_ROLE[role as UserRole],
    }));
  const dataSource = useArrayDataSource({ items: roles }, []);

  return (
    <PickerInput
      disableClear
      dataSource={dataSource}
      dropdownPlacement="bottom-end"
      entityName="name"
      getName={(item) => item.value}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      minBodyWidth={200}
      searchPosition="none"
      selectionMode="single"
      size="36"
      validationMessage={validationMessage}
      validationProps={validationProps}
      value={value}
      valueType="id"
      onValueChange={onValueChange}
    />
  );
};
